<template>
  <div class="container">
    <div id="title">
      <span>香の川製麺の味を、お好きな時に楽しもう</span>
    </div>
    <div
      class="btn_area"
      @click="
        openNetStore('https://joyfull.official.ec')
        trapTrackNetShopEvent('Joyfull')
      "
    >
    </div>
    <div
      class="btn_area"
      @click="
        openNetStore('https://amzn.to/2OO03Cv')
        trapTrackNetShopEvent('Amazon')
      "
    >
      <div class="image">
        <img src="@/assets/img/netorder/amazon_btn.png" alt="" />
      </div>
    </div>
    <div
      class="btn_area"
      @click="
        openNetStore('https://bit.ly/3585912')
        trapTrackNetShopEvent('Rakuten')
      "
    >
      <div class="image">
        <img src="@/assets/img/netorder/rakuten_btn.png" alt="" />
      </div>
    </div>
    <div
      class="btn_area"
      @click="
        openNetStore('https://bit.ly/3eOY5wq')
        trapTrackNetShopEvent('yahoo')
      "
    >
      <div class="image">
        <img src="@/assets/img/netorder/yahoo_btn.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'
export default {
  name: 'NetOrder',
  created() {
    document.title = 'ネット通販'
    this.trackEvent(FactoryTrack.createNetorder())
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', ['actionRequestExternalLink']),
    openNetStore(url) {
      this.actionRequestExternalLink(url)
    },
    trapTrackNetShopEvent(caption) {
      this.trackEvent(FactoryTrack.createNetShop(caption))
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 100vh;
  background-color: #ffffff;

  #image_area {
    width: 100%;
    height: auto;
  }

  #image_area img {
    width: 100%;
    height: auto;
  }

  #title {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    color: rgba(90, 34, 0, 1);
  }

  #title span {
    width: 100%;
  }

  #description {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 30px;
    align-items: center;
    display: flex;
    line-height: 21px;
    text-align: center;
    font-weight: normal;
    font-size: 12px;
    color: rgba(34, 34, 34, 1);
  }

  #description span {
    width: 100%;
  }

  .btn_area {
    width: 100%;
    padding-left: 15px;
    padding-top: 0px;
    padding-bottom: 15px;
    background-color: #ffffff;
  }
  .btn_area .image {
    width: 95%;
    align-items: center;
  }

  .btn_area .image img {
    width: 100%;
  }
}
</style>
